import React from 'react';
import {
  Button, Dialog, DialogContent, DialogActions,
} from '@material-ui/core';

import { closeWebView, isWebView } from '../../utils';

interface Props {
  onClose?: () => void;
  onRetry?: () => void;
  open: boolean;
}

const RetryDialog: React.FC<Props> = ({
  children,
  onClose = (): void => undefined,
  onRetry = (): void => undefined,
  open = false,
  ...otherProps
}) => {
  const handleRetry = (): void => {
    onRetry();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} {...otherProps}>
      <DialogContent>
        {children}
      </DialogContent>
      <DialogActions>
        <Button type="button" onClick={isWebView() ? closeWebView : onClose}>닫기</Button>
        <Button type="button" color="secondary" onClick={handleRetry}>재시도</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RetryDialog;
